import { t } from "ttag";

import { Link } from "metabase/common/components/Link";
import SidesheetStyles from "metabase/common/components/Sidesheet/sidesheet.module.css";
import { canAccessUsageAnalytics } from "metabase/common/monitor/selectors";
import type { InsightsLinkProps } from "metabase/plugins";
import { useSelector } from "metabase/redux";
import { Flex, Icon } from "metabase/ui";
import * as Urls from "metabase/urls";

function getUsageHistoryUrl({
  question,
  dashboard,
}: Pick<InsightsLinkProps, "question" | "dashboard">): string | null {
  const questionId = question?.id();
  if (questionId != null) {
    return Urls.monitorUsageItem("card", questionId);
  }
  // a dashboard with a string id is generated on the fly, and has no history
  if (typeof dashboard?.id === "number") {
    return Urls.monitorUsageItem("dashboard", dashboard.id);
  }
  return null;
}

/**
 * Links a question's or dashboard's info sidebar to who viewed, ran and
 * changed it. Only for people who may read the usage analytics.
 */
export function UsageHistoryLink({
  question,
  dashboard,
  ...linkProps
}: InsightsLinkProps) {
  const canAccess = useSelector(canAccessUsageAnalytics);
  const url = getUsageHistoryUrl({ question, dashboard });

  if (!canAccess || url == null) {
    return null;
  }
  return (
    <Link {...linkProps} to={url}>
      <Flex gap="xxs" className={SidesheetStyles.TabSibling}>
        <Icon name="audit" />
        {t`Usage history`}
      </Flex>
    </Link>
  );
}
